import React, { useEffect, useState , useRef} from "react";
import LearnBook from "../../components/LearnBook/LearnBook";
import Tab from "../../components/nav/Tab";
import { IMAGE_BASE_URL } from "../../Common/constant";
import Loading from "../../components/Loading/Loading";
import ScrollLoading from "../../components/Loading/ScrollLoading";

//filter
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

//Redux Action
import { connect } from "react-redux";
import { fetchPosts, getSubCategories } from "../../redux/Actions/postAction";
import { useDispatch } from "react-redux";
import { RESET_LEARN_POSTS } from "../../redux/Actions/postAction";

import '../../components/LearnBook/learnstyle.css';

const Learn = (props) => {
  const dispatch = useDispatch();
  useEffect(()=>{
    dispatch({
      type: RESET_LEARN_POSTS,
      payload: [],
    });
  })
  const ref = useRef(null);

  const [isLoading, setIsLoading] = useState(false);
  const [isActive, setIsActive] = useState(false);

  // limited posts
  const [posts, setPosts] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [page, setPage] = useState(0);
  const [subCategoryCode,setSubCategoryCode]= useState(null);

  const { BookData, fetchPosts, LearnSub , getSubCategories } = props;

  const size = BookData.size;
  const data  = BookData.records;

  let ph = localStorage.getItem('phone');
  const phone = ph.substring(2);

  const auth_code = localStorage.getItem('authorization_code');

  function getPost(subCategory) {
    if(auth_code !== null){
      getSubCategories("C-0002", 'learn');
      fetchPosts("C-0002",subCategory,page,'learn',auth_code);
      setIsFetching(false);
    }
  }
  function getMorePosts() {
    setTimeout(() => {
      setPage(page + 5);
      getPost(subCategoryCode);
    }, 4000);
  }

  function handleScroll() {
    if (window.innerHeight !== document.documentElement.offsetHeight) {
      setIsFetching(true);
    }else{
      setIsFetching(false);
    }
   }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  useEffect(() => {
    if(auth_code !== null){
      if(subCategoryCode === null){
        getPost('all');
        setSubCategoryCode('all');
        setPage(5);
      }else{
        getPost(subCategoryCode);
        setPage(5);
      }
    }
  }, [subCategoryCode]);

  useEffect(() => {
    if (!isFetching) {
      return;
    } else {
      if(page <= size){
       getMorePosts();
      }else{
       setIsFetching(false);
      }
    }
  }, [isFetching]);

  useEffect(() => {
    if(data !== undefined){
      if (data.length > 0 && data !== undefined) {
       setPosts([...posts, ...data]);
       setIsLoading(false);
     } else {
       setIsLoading(false);
     }}
   }, [data]);

   useEffect(() => {
    if(LearnSub !== undefined){
      if (LearnSub.length > 0 && LearnSub !== undefined) {
       setIsActive(false);
     } else {
       setIsActive(true);
     }}
   }, [LearnSub]);

   let primaryColor = ["#fb9051",'#ed8141','#fb6f1b'];
   let secondaryColor = ["#ed8141",'#fb6f1b','#fb9051'];

  const settings = {
    focusOnSelect: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: true,
    swipeToSlide: true,
    arrows : false,
  };
  
  const handleClick = (value,e) =>{ //when click sub category
    setPosts([]);
    setPage(0);
    setIsLoading(true);
    setSubCategoryCode(value);
    Array.from(document.querySelectorAll('.btn-slick')).forEach(function(el) { 
      el.classList.remove('active');
    });
    e.currentTarget.classList.toggle('active');
  }


  return (
    <>
      <Tab active="2px solid #fc7321" background="#fc7321" />

      <div className="learn_container">
        <div className="learn_main_container">
          {isActive ? (
            <ScrollLoading color="#00A8FF" />
          ) : (
            <div className="filter-container">
              <p className="text-center slick_title">မျက်မှောက်ခေတ်တွင် အသိပညာ၊ ဗဟုသုတများကို ကျွမ်းဝင်နေစေရန် ကြိုးပမ်း အားထုတ်နေကြရုံမျှမက နည်းမှန် လမ်းမှန် လက်တွေ့ အသုံးချနိုင်ရန် လိုအပ်သည့် အချက်အလက်များကို Learn ကဏ္ဍတွင် လေ့လာနိုင်ပါသည်။</p>
              <Slider {...settings}>
                <div className="slick-item">
                  <a className="btn btn-slick learn-btn px-4 mx-1 active" ref={ref} onClick={(e) => handleClick('all',e)}>All</a>
                </div>
                {
                  LearnSub && LearnSub.map(function(sub, index){
                    return (
                      <div className="slick-item" key={index}>
                        <a className="btn btn-slick learn-btn px-4 mx-1" onClick={(e) => handleClick(sub.sub_category_code,e)}>{sub.sub_category_name}</a>
                      </div>
                    );

                  })
                }
              </Slider>
            </div>
          )}
          {isLoading ? (
            <div
              style={{
                marginTop: "150px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Loading color="#F6C063" />
            </div>
          ) : (
            posts.map((book, index) => (
              <LearnBook
                key={index}
                bookID={book.id}
                count={book.count}
                date={book.published_date}
                rate={book.rates.length > 0 ? book.rates[0].rate : 1}
                title={book.post_name}
                img={IMAGE_BASE_URL + book.images}
                subTitle={book.subcategory.sub_category_name}
                primaryColor={primaryColor[index % 3]}
                secondaryColor={secondaryColor[index % 3]}
                postType={book.post_type}
                postSave={
                  book.post_save &&
                  book.post_save.phone == phone
                    ? "save"
                    : ""
                }
              />
            ))
          )}
          {isFetching && <ScrollLoading color="#00A8FF" />}
        </div>
      </div>

    </>
  );
};

const mapStateToProps = (state) => {
  return {
    BookData: state.post.learn_posts,
    LearnSub : state.post.learn_sub
  };
};

export default connect(mapStateToProps, {
  fetchPosts,
  getSubCategories
})(Learn);
